import { useQuery } from '@tanstack/react-query';
import { listQuickstarts, type DmQuickstart } from '../services/dmQuickstarts';

export function useDmQuickstarts(patientId: string | undefined) {
    const { data, error, isLoading } = useQuery<DmQuickstart[]>({
        queryKey: ['v2/patients', patientId, 'dm', 'monitoring', 'quickstarts'],
        queryFn: () => listQuickstarts(patientId!),
        enabled: !!patientId,
        staleTime: 5 * 60 * 1000
    });

    return { data: data ?? [], isLoading, error };
}
